//Mixin pour les icônes des réseaux sociaux
export const ednSocialIcon = {
  data() {
    return {
      arrSocial: ['twitter', 'linkedin', 'facebook','google','youtube','whatsapp','skype','instagram']
    }
  },
  computed: {
    getPrepIcon: {
      get: function() {
        return this.socialIcon ? this.socialIcon : ''
      },
      set: function(newValue) {
        this.$emit('update:socialIcon',newValue);
      },
    },
    /**
     * Récupère l'icône correspond au préfixe de l'url
     */
    getPrefixIcon(){
      if(this.isUrlPrefixed && this.arrSocial.find(social => this.prefix.includes(social)) != undefined)  {
        return 'mdi-' + this.arrSocial.find(social => this.prefix.includes(social))
      }else return false;
    },
    /**
     * Renvoie l'icône de réseau social fournie via la props socialIcon ou l'icône correspond au prefixe de l'url sinon
     */
    getSocialIcon(){
      if(this.socialIcon && this.arrSocial.find(social => this.socialIcon.includes(social)) != undefined) return this.socialIcon;
      else return this.getPrefixIcon;
    }
  },
}
